
import { defineComponent, onMounted } from "vue";
import router from "@/router/router";
import { BaseSpinner } from "@/components/Base"

export default defineComponent({
  name: "callback",
  components: {
    BaseSpinner
  },
  setup() {
    router.push({ name: "dashboard" })
  },
});
